import { TasksBoardComponent } from "@/components/shared";
import { FetchTasksByTenderIdQuery, FetchTasksByTenderIdQueryVariables, FetchTasksByTenderIdDocument, Task } from "@/graphql/__generated__/graphql";
import { useTenderPermissionsData } from "@/hooks/cache";
import { useParams } from "react-router-dom";
import { useQuery } from "@apollo/client/react";

function TasksBoard() {

  const { tenderID } = useParams<{ tenderID: string }>();
  const { canManageTask } = useTenderPermissionsData(Number(tenderID));

  const { data, loading } = useQuery<FetchTasksByTenderIdQuery, FetchTasksByTenderIdQueryVariables>(FetchTasksByTenderIdDocument, {
    variables: { tenderId: Number(tenderID) },
    fetchPolicy: "cache-and-network",
  });

  const tenderTasks = data?.fetchTasksByTenderId || [];

  return (
    <div className="w-full h-[calc(100vh-100px)] overflow-x-auto overflow-y-auto pr-4 pl-2">
      <div className="min-w-[800px] h-full">
        <TasksBoardComponent tasks={tenderTasks as Task[]} type="tender" loading={loading} canEdit={canManageTask}/>
      </div>
    </div>
  );
}

export default TasksBoard;
